import Image from 'next/image';
import { memo } from 'react';

import { ImgixImage } from '@air/component-imgix-image';

const isLocalThumbnailSrc = (src: string): boolean => src.startsWith('data:') || src.startsWith('blob:');

export type WorkspaceUploadsListItemThumbnailProps = {
  ext: string;
  thumbnailSource: string | undefined;
};

export type ThumbnailImageProps = {
  src: string;
};

const ThumbnailImage = memo(({ src }: ThumbnailImageProps) => {
  const thumbnailProps = {
    alt: '',
    className: 'relative mr-3 size-10 shrink-0 rounded-4 object-cover ring-2 ring-gray-1',
    'data-testid': 'WORKSPACE_UPLOADS_ITEM_THUMBNAIL',
    height: 40,
    src,
    width: 40,
  };

  if (isLocalThumbnailSrc(src)) {
    return <Image {...thumbnailProps} />;
  }

  return <ImgixImage {...thumbnailProps} />;
});

ThumbnailImage.displayName = 'ThumbnailImage';

export const WorkspaceUploadsListItemThumbnail = memo(
  ({ ext, thumbnailSource }: WorkspaceUploadsListItemThumbnailProps) => {
    if (thumbnailSource) {
      return <ThumbnailImage src={thumbnailSource} />;
    }

    return (
      <span
        className="relative mr-3 flex size-10 shrink-0 items-center justify-center rounded-4 ads:bg-subtle bg-gray-3 font-semibold ads:text-metadata text-10 text-gray-10 uppercase ring-2 ring-gray-1"
        data-testid="WORKSPACE_UPLOADS_ITEM_THUMBNAIL"
      >
        {ext}
      </span>
    );
  },
);

WorkspaceUploadsListItemThumbnail.displayName = 'WorkspaceUploadsListItemThumbnail';
